import { OnlineStatus } from '@/modules/car/model';

const getOnlineStatus = ({ online, busy }: { online?: boolean; busy?: boolean }): OnlineStatus => {
  if (busy) {
    return 'busy';
  }

  if (online) {
    return 'online';
  }

  return 'offline';
};

export { getOnlineStatus };
